/* COLOMBY COFFEE — interactions */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isRTL = document.documentElement.dir === 'rtl';

  /* Touch screens: a finger scrolling past a product card fires
     "pointerenter", which made Horizon cards swap to their second photo.
     Stop that event for touch and pen only; mouse hover is unchanged. */
  ['pointerenter', 'pointerleave'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.pointerType === 'mouse') return;
      var t = e.target;
      if (t && t.nodeType === 1 && t.classList && t.classList.contains('card-gallery')) e.stopPropagation();
    }, true);
  });

  /* Pause decorative motion while it is off screen, so scrolling on a
     phone is not competing with animations nobody can see. */
  if ('IntersectionObserver' in window) {
    var pauseObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('cb-offscreen', !en.isIntersecting); });
    }, { rootMargin: '100px 0px' });
    var watchMotion = function (root) {
      root.querySelectorAll('.cb-ann, .cb-bigmarquee, .cb-roast, .cb-offer, .cb-mood').forEach(function (el) {
        if (el._cbPause) return;
        el._cbPause = true;
        pauseObserver.observe(el);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watchMotion(document); });
    else watchMotion(document);
    document.addEventListener('shopify:section:load', function (e) { watchMotion(e.target); });
  }

  /* Reveal on scroll */
  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            revealObserver.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 })
    : null;

  function initReveal(root) {
    root.querySelectorAll('[data-cb-reveal]:not(.is-in)').forEach(function (el) {
      if (revealObserver && !reduce) revealObserver.observe(el);
      else el.classList.add('is-in');
    });
  }

  /* Toast */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cb-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }

  /* Copy discount code */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cb-copy]');
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-cb-copy');
    var done = function () { toast('تم نسخ الكود ' + code); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var t = document.createElement('textarea');
      t.value = code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {}
      t.remove(); done();
    }
  });

  /* Add-to-cart pending mark (bean + horse).
     Shown only while the /cart/add request is in flight, and only if it takes
     longer than 180ms, so fast adds never flash. Never delays the cart. */
  var loaderTpl = document.getElementById('cb-loader-tpl');
  document.addEventListener('click', function (e) {
    if (!loaderTpl) return;
    var btn = e.target.closest('add-to-cart-component button[name="add"]');
    if (!btn || btn.disabled || btn.classList.contains('cb-atc-pending')) return;
    if (btn.form && typeof btn.form.checkValidity === 'function' && !btn.form.checkValidity()) return;
    var host = btn.closest('add-to-cart-component') || btn;
    var showTimer, failTimer, observer, perf;

    function finish() {
      clearTimeout(showTimer);
      clearTimeout(failTimer);
      if (observer) observer.disconnect();
      if (perf) perf.disconnect();
      btn.classList.remove('cb-atc-pending');
      btn.removeAttribute('aria-busy');
    }

    showTimer = setTimeout(function () {
      if (!btn.isConnected) return;
      if (!btn.querySelector('.cb-loader')) btn.appendChild(loaderTpl.content.cloneNode(true));
      btn.classList.add('cb-atc-pending');
      btn.setAttribute('aria-busy', 'true');
    }, 180);

    /* Done when the add request has returned (success or error). */
    if ('PerformanceObserver' in window) {
      try {
        perf = new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (entry) {
            if (/\/cart\/add/.test(entry.name)) finish();
          });
        });
        perf.observe({ type: 'resource' });
      } catch (err) { perf = null; }
    }
    if ('MutationObserver' in window) {
      observer = new MutationObserver(function () {
        if (host.matches('[data-added="true"]') || host.querySelector('[data-added="true"]')) finish();
      });
      observer.observe(host, { attributes: true, subtree: true, attributeFilter: ['data-added'] });
    }
    /* Safety net: request never fired, or the button was re-rendered. */
    failTimer = setTimeout(finish, 6000);
  }, true);

  /* Hero slider */
  function initHero(root) {
    root.querySelectorAll('[data-cb-hero]').forEach(function (hero) {
      if (hero._cbInit) return;
      hero._cbInit = true;
      var slides = Array.prototype.slice.call(hero.querySelectorAll('.cb-slide'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('.cb-hero__dot'));
      var speed = parseInt(hero.getAttribute('data-speed'), 10) || 6000;
      var idx = 0, timer = null;

      function go(i) {
        if (!slides.length) return;
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === idx);
          s.setAttribute('aria-hidden', n === idx ? 'false' : 'true');
        });
        dots.forEach(function (d, n) {
          d.classList.remove('is-active');
          void d.offsetWidth;
          if (n === idx) d.classList.add('is-active');
          d.setAttribute('aria-current', n === idx ? 'true' : 'false');
        });
        schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (slides.length > 1 && !reduce && !hero.classList.contains('is-paused') && !hero.classList.contains('is-offscreen')) {
          timer = setTimeout(function () { go(idx + 1); }, speed);
        }
      }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
      hero.addEventListener('mouseenter', function () { hero.classList.add('is-paused'); clearTimeout(timer); });
      hero.addEventListener('mouseleave', function () { hero.classList.remove('is-paused'); schedule(); });

      /* Swipe changes slide only on a clearly sideways gesture, so scrolling
         the page past the hero never flips the slide by accident. */
      var sx = null, sy = null;
      hero.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.6) go(idx + ((dx < 0) !== isRTL ? 1 : -1));
        sx = sy = null;
      }, { passive: true });
      hero.addEventListener('touchcancel', function () { sx = sy = null; }, { passive: true });

      if (!reduce && window.matchMedia('(pointer: fine)').matches) {
        var beans = hero.querySelectorAll('.cb-hero__bean');
        var media = hero.querySelectorAll('.cb-slide__media');
        hero.addEventListener('mousemove', function (e) {
          var r = hero.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          beans.forEach(function (b) {
            var depth = parseFloat(b.getAttribute('data-depth')) || 20;
            b.style.setProperty('--px', (x * depth).toFixed(1) + 'px');
            b.style.setProperty('--py', (y * depth).toFixed(1) + 'px');
          });
          media.forEach(function (m) {
            m.style.transform = 'translate3d(' + (x * -14).toFixed(1) + 'px,' + (y * -10).toFixed(1) + 'px,0)';
          });
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (x) {
            if (x.isIntersecting) { hero.classList.remove('is-offscreen'); schedule(); }
            else { hero.classList.add('is-offscreen'); clearTimeout(timer); }
          });
        }).observe(hero);
      }
      go(0);
    });
  }

  /* Carousels */
  function initCarousels(root) {
    root.querySelectorAll('[data-cb-carousel]').forEach(function (wrap) {
      if (wrap._cbInit) return;
      wrap._cbInit = true;
      var track = wrap.querySelector('.cb-carousel__track');
      var section = wrap.closest('.cb-section') || wrap;
      section.querySelectorAll('[data-cb-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-cb-dir') === 'next' ? 1 : -1;
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 20 : 300;
          track.scrollBy({ left: dir * step * (isRTL ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* Roast finder tabs */
  function initTabs(root) {
    root.querySelectorAll('[data-cb-roast]').forEach(function (wrap) {
      if (wrap._cbInit) return;
      wrap._cbInit = true;
      var tabs = wrap.querySelectorAll('[role="tab"]');
      var panels = wrap.querySelectorAll('.cb-roast__panel');
      var visuals = wrap.querySelectorAll('[data-roast-visual]');
      function select(i) {
        tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); t.tabIndex = n === i ? 0 : -1; });
        panels.forEach(function (p, n) {
          p.classList.toggle('is-active', n === i);
          if (n === i) {
            p.querySelectorAll('.cb-meter__bar span.on').forEach(function (s) { s.classList.remove('on'); void s.offsetWidth; s.classList.add('on'); });
          }
        });
        visuals.forEach(function (v, n) { v.hidden = n !== i; });
        var color = tabs[i] && tabs[i].getAttribute('data-roast-color');
        if (color) wrap.style.setProperty('--roast', color);
      }
      tabs.forEach(function (t, n) {
        t.addEventListener('click', function () { select(n); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, next = null;
          if (k === 'ArrowLeft') next = isRTL ? n + 1 : n - 1;
          if (k === 'ArrowRight') next = isRTL ? n - 1 : n + 1;
          if (next !== null) { e.preventDefault(); next = (next + tabs.length) % tabs.length; select(next); tabs[next].focus(); }
        });
      });
      select(0);
    });
  }

  /* Reels: play videos in view */
  function initReels(root) {
    var vids = root.querySelectorAll('.cb-reel video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        var v = x.target;
        v.muted = true;
        if (x.isIntersecting && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initHero(root);
    initCarousels(root);
    initTabs(root);
    initReels(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.cb-slide');
    var hero = e.target.closest('[data-cb-hero]');
    if (slide && hero) {
      var i = Array.prototype.indexOf.call(hero.querySelectorAll('.cb-slide'), slide);
      var dot = hero.querySelectorAll('.cb-hero__dot')[i];
      if (dot) dot.click();
    }
  });
})();
